<template>
  <div 
      :class="[
        'com-anm22-app-white-container',
        'expense-box',
        mergingOutgoId && outgoId === mergingOutgoId ? 'selected notActive' : '',
        mergingOutgoId && !selectable ? 'notActive' : ''
      ]">
    <div class="wg-row">
      <div 
          class="wg-col wg-xs-9 display-flex" 
          style="cursor:pointer;"
          @click="$emit('openOutgoEvent', outgoId)">
        <img 
            v-if="!isSynchronized || !isOutgoImagesSynchronized"
            :src="$anm22.icons.getWorldIcon('offline')"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-right:5px;"
            :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
        >
        <div class="expense-icon" :style="'background-image:url('+categoryImg+');'"></div>
        <div class="expense-payment-mode" style="display:flex;align-items:center;">
          {{ paymentModeString }}
          <img v-if="card" :src="cardImg">
          <img 
              :src="verificationTypeImg"
              :title="verificationTypeLabel">
          <img 
              v-if="outgo.images.length > 0"
              :src="$anm22.icons.getTasksIcon('photoCamera')"
              :title="$anm22.strLang(lang, 'Invoice photo', 'Foto scontrino')">
        </div>
        <div class="expense-description">
          {{ category ? category.name : '' }}
        </div>
        <div class="vertical-height-div" style="height:1px;"></div>
        <div 
            v-if="showDescription" 
            class="expense-description" 
            :title="outgoDescTitle">
          {{ outgoDesc }}
        </div>
      </div>
      <div class="wg-col wg-xs-3">
        <div class="expense-date" :title="$moment.unix(outgo.outgoDate).utc().format('DD MMMM YYYY')">
          {{ outgoDate }}
        </div>
        <div>
          <div class="display-flex expense-amount" :style="amountColor">
            {{ amount }}
            <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
            <div class="com-anm22-app-text-m">{{ $anm22.tableClasses.worldCurrencyType().getById(outgo.currencyType)[lang] }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row expense-menu" style="align-items:center;">
      <div class="wg-col wg-xs-9">
        <div class="wg-row expense-user" style="align-items:center;">
          <!-- <template v-if="outgoUser">
            <img 
                v-if="outgoUser.image !== '' || (outgoUser.fbId && outgoUser.fbId !== '' && outgoUser.fbId != 0)"
                :src="$anm22.getObjIcon(outgoUser, 'userDefault')"
                :title="outgoUser.name + ' ' + outgoUser.surname"
                class="com-anm22-app-img-fixed-height-s com-anm22-round"
                style="margin-right:5px;"
            >
            <div 
                v-else
                class="project-list-user"
                :title="outgoUser.name + ' ' + outgoUser.surname"
                style="width:22px;height:22px;border-radius:11px;padding-top:4px;margin:0 5px 0 0;"
            >
              {{ outgoUser.name.substring(0,1) + outgoUser.surname.substring(0,1) }}
            </div>
          </template> -->
          <div 
              v-if="outgoUser"
              style="min-width:22px;width:22px;height:22px;margin-right:5px;">
            <world-object-icon
                :type="'user'" 
                :obj="outgoUser"
                :isImg="true">
            </world-object-icon>
          </div>
          {{ userName }}
        </div>
      </div>
      <div class="wg-col wg-xs-3 display-flex expense-actions" style="justify-content:flex-end;">
        <template v-if="!outgo.masterOutgo">
          <template v-if="mergeButton">
            <img 
                v-if="!outgo.verificationType || outgo.verificationType !== 1"
                :src="$anm22.icons.getWorldIcon('link')"
                class="expense-merge-btn"
                style="cursor:pointer;"
                @click="$emit('startMergingEvent', outgoId)"
                >
            <div
                v-if="!outgo.verificationType || outgo.verificationType !== 2"
                :class="['expense-merge-anchor', selectable ? 'selectable' : '']"
                :style="anchorStyle"
                @click="selectable ? $emit('mergeExpenseEvent', outgoId) : ''">
            </div>
            <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
          </template>
          <img 
              v-if="canEdit"
              :src="$anm22.icons.getWorldIcon('edit')"
              class="com-anm22-app-img-fixed-height-m expense-act-btn"
              @click="$emit('openOutgoEvent', outgoId)"
              >
          <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
          <img 
              v-if="canDelete"
              :src="$anm22.icons.getWorldIcon('deleteBin')"
              class="com-anm22-app-img-fixed-height-m expense-act-btn"
              @click="$emit('deleteOutgoEvent', outgo)"
              >
        </template>
        <template v-else>

        </template>
      </div>
    </div>
  </div>
</template> 

<script>
import { mapState } from "vuex";

export default {
  props: {
    outgoId: [Number, String],
    canEdit:Boolean,
    canDelete: Boolean,
    showDescription: Boolean,
    fullDescription: Boolean,
    // ------------------------
    // Gestione merging delle spese
    mergeButton: {
      type: Boolean,
      default: true
    },
    mergingOutgoId: Number,
    // -----------------------
    deleteSuccessFn: Function,
    editSuccessFn: Function,
    splitSuccessFn: Function
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    outgo() {
      return this.$store.getters["outgoes/get"](this.outgoId);
    },
    isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldOutgo' + this.outgoId));
    },
    isOutgoImagesSynchronized() {
      let isOutgoSync = true;
      this.outgo.images.forEach(image => {
        if (!this.isImageSynchronized(image))  {
          isOutgoSync = false;
        }
      });
      return isOutgoSync;
    },
    mergingOutgo() {
      return this.$store.getters['outgoes/get'](this.mergingOutgoId) || null;
    },
    outgoUser() {
      return this.$store.getters['users/get'](this.outgo.user);
    },
    category() {
      return this.$store.getters["outgoCategories/get"](this.outgo.category);
    },
    outgoDesc() {
      if (this.outgo && this.outgo.description) {
        if (this.outgo.description.length > 100) {
          return this.outgo.description.substring(0, 100) + "...";
        } else {
          return this.outgo.description;
        }
      } else {
        return "";
      }
    },
    outgoDescTitle() {
      return this.outgo && this.outgo.description
        ? this.outgo.description.replace('"', "&quot;")
        : "";
    },
    categoryImg() {
      if (this.category && this.category.img && this.category.img !== "") {
        return "../../calendar/images/activities/" + this.category.img + "";
      } else {
        return this.$anm22.icons.getWorldIcon("money");
      }
    },
    card() {
      if (
        this.outgo.card &&
        this.outgo.card !== "" &&
        (this.outgo.card === this.outgo.paymentMode ||
          this.outgo.paymentMode === 1)
      ) {
        return this.$store.getters["cards/get"](this.outgo.card);
      } else {
        return null;
      }
    },
    paymentModeString() {
      if (this.card) {
        if (this.card.name && this.card.name !== "") {
          return this.card.name;
        } else {
          return "..." + this.card.number.substring(-4);
        }
      } else if (
        this.outgo.bankAccount &&
        this.outgo.bankAccount !== "" &&
        (this.outgo.bankAccount === this.outgo.paymentMode ||
          this.outgo.paymentMode === 2)
      ) {
        return this.$anm22.strLang(this.lang, "Bank", "Banca");
      } else {
        return this.$anm22.strLang(this.lang, "Cash", "Contanti");
      }
    },
    cardImg() {
      if (this.card) {
        const cardType = this.$store.getters["cardTypes/get"](
          this.card.cardType
        );
        return (
          "../../world/libs/anm22_icons/img/credit_card_brands/" +
          cardType.system +
          ".png"
        );
      } else {
        return "";
      }
    },
    verificationTypeImg() {
      if (!!this.outgo.verificationType) {
        switch (this.outgo.verificationType.toString()) {
          case "1":
            return "../../pay/utilities/img/icons/check_circle_black.svg";
          case "2":
            return "../../pay/utilities/img/icons/timeline_black.svg";
          case "3":
            return "../../pay/utilities/img/icons/pan_tool_black.svg";
        }
      }
    },
    verificationTypeLabel() {
      if (!!this.outgo.verificationType) {
        switch (this.outgo.verificationType.toString()) {
          case "1":
            return this.$anm22.strLang(
              this.lang,
              "Verified expense",
              "Spesa verificata"
            );
          case "2":
            return this.$anm22.strLang(
              this.lang,
              "Imported expense",
              "Spesa importata "
            );
          case "3":
            return this.$anm22.strLang(
              this.lang,
              "Manually verified expense",
              "Spesa verificata manualmente"
            );
        }
      }
    },
    outgoDate() {
      const date = this.$moment.unix(this.outgo.outgoDate).utc();
      if (date.format("Y") !== this.$moment().format("Y")) {
        return date.utc().format("DD MMM Y");
      } else {
        return date.utc().format("DD MMM");
      }
    },
    amount() {
      return this.outgo.amount < 0
        ? "+" + this.outgo.amount * -1
        : "-" + this.outgo.amount;
    },
    amountColor() {
      return this.outgo.amount < 0 ? "color:#01d479" : "";
    },
    userName() {
      if (this.outgo.user) {
        const u = this.$store.getters["users/get"](this.outgo.user);
        return u.name.substring(0, 1) + ". " + u.surname;
      } else {
        return this.$anm22.strLang(
          this.lang,
          "<No user>",
          "<Nessun utente>"
        );
      }
    },
    // Gestione merging delle spese
    selectable() {
      if(this.mergingOutgo){
        return this.outgoId !== this.mergingOutgoId
          && (
            this.outgo.currencyType === this.mergingOutgo.currencyType
            || this.outgo.exchangeCurrency === this.mergingOutgo.exchangeCurrency
          )
      } else {
        return false;
      }
    }
  },
  methods: {
    isImageSynchronized(image) {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldOutgoImage' + image.syncId));
    }
  }
};
</script>

<style lang="scss" scoped>
.expense-box.selected {
  border: 2px solid #40c4ff;
}
.expense-box.notActive {
  opacity: 0.4;
}
.expense-merge-anchor.selectable {
  border: 2px solid #40c4ff;
  cursor: pointer;
  &:hover {
    background-color: #40c4ff;
  }
}
.expense-act-btn {
  cursor: pointer;
  opacity: 0.7;
  padding: 1px;
  box-sizing: border-box;
}
</style>
